import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Realisations from './components/Realisations';


function App() {
  return (
    <div className="app">
      <Header />
      <main>
        <Hero />
        <Services />
        <Realisations />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
